    <div autofocus class="search-contents">
        <div>
            <mat-form-field>
                <mat-select placeholder="{{'historyTexts.orderStatus' | translate}}" [(ngModel)]="displayOptions.status"
                    (selectionChange)="setOrderStatus()">
                    <mat-option *ngFor="let s of statusLables" [value]="s">
                        {{getDocumentStatusText(s)}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field>
                <input matInput [matDatepicker]="startDate" placeholder="{{'historyTexts.startDate' | translate}}"
                    [(ngModel)]="fromDate" (ngModelChange)="setRequestDates()" [max]="maxStartDateValue">
                <mat-datepicker-toggle matSuffix [for]="startDate">
                    <cqes-icon icon="calendar_today" class="calendar-icon">
                    </cqes-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #startDate></mat-datepicker>
            </mat-form-field>

            <mat-form-field>
                <input matInput [matDatepicker]="endDate" placeholder="{{'historyTexts.endDate' | translate}}"
                    [(ngModel)]="toDate" (ngModelChange)="setRequestDates()" [min]="minEndDateValue">
                <mat-datepicker-toggle matSuffix [for]="endDate">
                    <cqes-icon icon="calendar_today" class="calendar-icon">
                    </cqes-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #endDate></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="search-container">
                <input class="search-input" matInput placeholder="{{'historyTexts.docName' | translate}}"
                    [(ngModel)]="displayOptions.textToShow" (keydown.enter)="searchRequestedDocument()">
                <button *ngIf="displayOptions.textToShow" class="close-button" matSuffix mat-icon-button [attr.aria-label]="'common.clear' | translate"
                    (click)="clearText()">
                    <cqes-icon icon="close">
                    </cqes-icon>
                </button>
            </mat-form-field>
        </div>


        <button class="mat-mdc-raised-button action-button" (click)="searchRequestedDocument()">
            {{'historyTexts.searchIntoSignDocs'
                | translate}}
        </button>

        <button class="mat-mdc-raised-button action-button" (click)="resetFilters()">
            {{'historyTexts.resetFilters' | translate}}
        </button>
    </div>

    <div class="message" *ngIf="!hasData() && !isLoading">
        {{'historyTexts.noDocumentsFound' | translate}}
    </div>

    <cloud-history-table-spinner *ngIf="isLoading"/>

    <div class="mat-elevation-z8 table-content" [hidden]="!hasData() || isLoading">
        <mat-table [dataSource]="requestedHistoryDataSource" matSort matSortActive="date" matSortDirection="desc">
            <ng-container matColumnDef="status">
                <mat-header-cell class="d-none d-sm-flex" *matHeaderCellDef>
                    {{'historyTexts.documentStatus' | translate}} </mat-header-cell>
                <mat-cell class="tac d-none d-sm-flex" *matCellDef="let row"
                    matTooltip="{{(row.statusIcon)?.tooltip | translate}}">
                    <cqes-icon [icon]="row.statusIcon.icon" [iconClass]="row.statusIcon.colorClass"></cqes-icon>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="signCountTxt">
                <mat-header-cell #signCountTxt class="d-block d-sm-flex" *matHeaderCellDef>
                    {{'historyTexts.signCount' | translate}} </mat-header-cell>
                <mat-cell class="d-block d-sm-flex" *matCellDef="let row"> {{row.signCountTxt}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="date">
                <mat-header-cell #date class="d-block d-sm-flex" *matHeaderCellDef mat-sort-header
                    (click)="sortByHeader(date)">
                    {{'historyTexts.createDate' | translate}}
                </mat-header-cell>
                <mat-cell class="d-block d-sm-flex" *matCellDef="let row">
                    {{row.date | date: dateFormat}}<br>{{row.date | date: timeFormat}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="downloadeTimestamp">
              <mat-header-cell #downloadeTimestamp class="d-block d-sm-flex" *matHeaderCellDef
                  mat-sort-header (click)="sortByHeader(downloadeTimestamp)">
                  {{'historyTexts.downloadeTimestampDate' | translate}}
              </mat-header-cell>
              <mat-cell class="d-block d-sm-flex" *matCellDef="let row">
                  {{row.downloadeTimestamp | date: dateFormat}}<br>{{row.downloadeTimestamp | date: timeFormat}}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="documentName">
                <mat-header-cell #documentName class="d-block d-lg-flex" *matHeaderCellDef mat-sort-header
                    (click)="sortByHeader(documentName)">
                    {{'historyTexts.docName'
                    | translate}} </mat-header-cell>
                <mat-cell class="d-block d-lg-flex truncate" *matCellDef="let row" #el
                [matTooltip]="(el.scrollWidth > el.clientWidth) ? row.documentName : ''"> {{row.documentName}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="downloadDocument">
                <mat-header-cell #downloadDocument class="d-sm-flex" *matHeaderCellDef>
                    {{'historyTexts.actions' | translate}}</mat-header-cell>
                <mat-cell class="d-sm-flex" *matCellDef="let row">
                    <div>
                        <span [matMenuTriggerFor]="actionsMenu">
                            <button mat-icon-button color="primary">
                                <cqes-icon icon="menu"></cqes-icon>
                            </button>
                        </span>
                        <mat-menu #actionsMenu [overlapTrigger]="false" class="nav-responsive-overlay menu">
                            <button mat-menu-item *ngIf="hasDownloadFileRequested(row)"
                                matTooltip="{{'historyTexts.downloadDocument' | translate}}"
                                (click)="onDownloadCert(row)">
                                <cqes-icon icon="file_download"></cqes-icon>
                                {{'historyTexts.downloadDoc' | translate}}
                            </button>
                            <button mat-menu-item color="primary" *ngIf="checkForDownload(row) && isArhived(row)"
                                matTooltip="{{'historyTexts.downloadSimpleReport' | translate}}"
                                (click)="onDownloadReport(row, 'SIMPLE')">
                                <cqes-icon icon="playlist_add_check"></cqes-icon>
                                {{'historyTexts.downloadEvedenceRecSimple' | translate}}
                            </button>
                            <button mat-menu-item color="primary" *ngIf="checkForDownload(row) && isArhived(row)"
                                matTooltip="{{'historyTexts.downloadDetailedReport' | translate}}"
                                (click)="onDownloadReport(row, 'DETAILED')">
                                <cqes-icon icon="playlist_add"></cqes-icon>
                                {{'historyTexts.downloadEvedenceRecExtend' | translate}}
                            </button>
                            <button [hidden]="isSubcomponent" mat-menu-item color="primary"
                                    matTooltip="{{'manageTexts.tooltips.showDetailsDocument' | translate}}"
                                    (click)="openRequestedDetailsDialog(row.requestedId)">
                                    <cqes-icon icon="info_outline"></cqes-icon>
                                    {{'manageTexts.inMenuInfo' | translate}}
                            </button>
                        </mat-menu>
                    </div>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
        <mat-paginator [pageSize]="tableHelper.pageSize" [pageSizeOptions]="tableHelper.pageSizeOptions"
            (page)="onPaginateChange($event)">
        </mat-paginator>
    </div>
